<ng-container *ngIf="!searchstr">
    {{label}}
</ng-container>
<ng-container *ngIf="searchstr">
    {{beforeMarked}}<mark>{{marked}}</mark>{{afterMarked}}
</ng-container>
